/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGMEDICAMENTEUXInner { 
    /**
     * EF_EP406.03 Alimentation obligatoire et uniquement si le type d\'élément prescrit est égal à « 01 ». Code sur 13 caractères.
     */
    CIP?: string;
    /**
     * EF_EP406.21 Commentaire relatif aux préparations magistrales. Alimentation obligatoire et uniquement si le type d\'élément prescrit est égal à « 04 ».
     */
    CommentairePM?: string;
    /**
     * EF_EP409.22 Données à caractère médical. Donnée alimentée par le PS ou le LPS(1).
     */
    DCM?: string;
    /**
     * EF_EP406.07 Durée du traitement en nombre de jours.
     */
    Duree?: number;
    /**
     * EF_EP409.04 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportALD: boolean;
    /**
     * EF_EP409.05 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportAccident: boolean;
    /**
     * EF_EP409.06 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportPrev: boolean;
    /**
     * EF_EP406.12 Hors Autorisation de Mise sur le Marché (AMM)
     */
    EstHorsAMM: boolean;
    /**
     * EF_EP409.07 Non remboursable. Donnée alimentée par le PS ou le LPS(1).
     */
    EstNonRemb: boolean;
    /**
     * EF_EP406.11 Donnée alimentée par le LPS(1) , doit être à « oui » si le motif de non substitution (EF_EP406.18) est renseigné.
     */
    EstNonSub: boolean;
    /**
     * EF_EP406.14 Code du médicament virtuel DCI Alimentation obligatoire si le type d\'élément prescrit est égal à « 02 » et si l’information est disponible dans la base médicaments du LPS.
     */
    IdMVN?: string;
    /**
     * EF_EP406.16 Code du médicament dans Medicabase Alimentation obligatoire si le type d\'élément prescrit est égal à « 02 » et si l’information est disponible dans la base médicaments du LPS.
     */
    Medicabase?: string;
    /**
     * Alimentation obligatoire et uniquement si le type d\'élément prescrit est égal à « 02 ». Doit contenir le nom de la ou des substance(s) active(s) en dénomination commune, le dosage respectif de chaque substance et la forme pharmaceutique.
     */
    Molecules?: string;
    /**
     * EF_EP406.18 Alimentation obligatoire si le médicament est non substituable (EF_EP406.11 = « oui »). Cf. liste des valeurs à renseigner dans le document [SEL-SFG-030].
     */
    MotifNonSub?: string;
    /**
     * EF_EP406.05 Nombre de conditionnements. Donnée alimentée par le LPS du prescripteur. Valorisée à « 1 » par défaut si la durée (EF_EP406.07) n’est pas renseignée et si le nombre de conditionnements n’a pas été explicitement renseigné par le PS ou si le module LAP ne calcule pas automatiquement le nombre de conditionnements à partir de la durée de traitement et de la spécialité choisie par le PS
     */
    NbConditionnement?: number;
    /**
     * Nombre de renouvellements.
     */
    NbRenouv: number;
    NumLigne: number;
    /**
     * EF_EP406.08 Posologie sous forme textuelle limitée à 1000 caractères maximum. En cas de dépassement de cette limite, tronquer la donnée à 1000 caractères. Une posologie simple s’exprime de la façon suivante  <nombre d’unités de prise> <unité de prise> <fréquence> <unité de temps> <voie d’administration>
     */
    Posologie: string;
    /**
     * EF_EP406.20 Médicament prescrit dans le cadre d’une Recommandation Temporaire d’Utilisation /d’un accès compassionnel
     */
    RTU: boolean;
    /**
     * EF_EP406.17 Spécialité médicamenteuse. Donnée alimentée par le LPS. Alimentation obligatoire uniquement si le type d\'élément prescrit est égal à « 01 ».
     */
    Specialite?: string;
    /**
     * Médicament prescrit dans le cadre d’un traitement antibiotique soumis à protocole. Donnée alimentée par le LPS(1). Remarque le PS n’a pas à renseigner pour chaque traitement antibiotique s’il est soumis à protocole. Donnée valorisée à « non » par défaut par le LPS.
     */
    TrtAntiBio: boolean;
    /**
     * Valeur « 01 » pour un médicament type code CIP. Valeur « 02 » pour un médicament en DC. Valeur « 04 » pour une préparation magistrale.
     */
    TypeEltPrescrit: string;
}

